import React, { useContext } from 'react';
import { AddStorageDataContext } from 'context/AddStorageContext';
import styled from 'styled-components';
import WhiteListContainer from 'sub_components/Storage/WhiteListContainer';

const attachSubnetToIps = ips => {
	return ips
		? ips.map(ip => {
				return /\/$/.test(ip) ? `${ip}32` : ip;
		  })
		: [];
};

const ShareWhitelistStyle = styled.div`
	.white-list-container {
		height: 150px !important;
	}
	.ScrollbarsCustom-Track {
		right: -8px !important;
		top: 11px !important;
	}
	.ScrollbarsCustom-ThumbY {
		background-color: ${props => props.theme.storage} !important;
		width: 6px !important;
	}
	.ScrollbarsCustom-TrackY:before {
		border-left: none;
	}
	.ScrollbarsCustom-TrackY {
		background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
		width: 6px !important;
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.white-list-container {
			height: 200px !important;
		}
		.ScrollbarsCustom-Track {
			right: 0px !important;
			top: 14px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.storage} !important;
			width: 8px !important;
		}

		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 8px !important;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.white-list-container {
			height: 350px !important;
		}
		.ScrollbarsCustom-Track {
			right: 5px !important;
			top: 24px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.storage} !important;
			width: 10px !important;
		}

		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 10px !important;
		}
	}
`;

export const ShareWhitelistScreen = () => {
	const { inputs, change } = useContext(AddStorageDataContext);
	const { whitelist, whitelist: { ips, dirty } = {} } = inputs;
	const formattedWhitelist = { ...whitelist, ips: attachSubnetToIps(ips) };

	function onSelect(name, data) {
		change({ target: { name, value: data?.data } });
		change({ target: { name: 'review', value: true } });
	}
	function update(name, data) {
		change({ target: { name, value: data } });
	}
	return (
		<ShareWhitelistStyle>
			<div className='whitelist-selection-stage'>
				<WhiteListContainer
					ips={formattedWhitelist}
					dirty={dirty}
					onSelect={onSelect}
					update={update}
					useButton={false}
				/>
			</div>
		</ShareWhitelistStyle>
	);
};
